<template>
<section class="photo-with-blurb bg-gray-500 px-4 py-4" :class="background_color">
    <SmoothLoader class="max-w-5xl mx-auto">
        <div class="grid" :class="`photo-on-${direction}`">
            <img :src="photo.src" :alt="photo.alt" class="rounded-md">
            <div class="blurb text-gray-900 flex items-center">
                <div>
                    <h2 class="font-headline text-3xl vt:text-5xl font-bold mb-6 text-secondary-600 leading-tight" v-if="headline" v-html="headline"></h2>
                    <div v-if="blurb" v-html="blurb" class="text-lg text-gray-800"></div>
                </div>
            </div>
        </div>
    </SmoothLoader>
</section>
</template>

<script>
// @purgecss bg-white bg-gray-500
export default {

    props: ['data'],

    setup(props) {
        return {
            ...props.data
        }
    }

}
</script>